import React from 'react';
import PurchaseCreditsModal from '../../../../Modals/Message/PurchaseCreditsModal';
import TipCreditModal from './TipCreditModal';

/**
 * Subscriber-only purchase + tip modals for the in-call screen.
 */
const CallingScreenSubscriberModals = ({
  showPurchaseCreditsModal,
  purchaseCreditsLowCreditMode,
  purchaseCreditsLowCreditMinutesRemaining,
  onClosePurchaseCredits,
  destUserInfo,
  resolvedUserId,
  callMediaType,
  openTipModalRefForCall,
  showTipModal,
  onCloseTipModal,
  handleTipSuccessInCall,
  handleOpenCredits,
}) => {
  return (
    <>
      <PurchaseCreditsModal
        isOpen={showPurchaseCreditsModal}
        variant={purchaseCreditsLowCreditMode ? 'lowCredit' : 'default'}
        lowCreditMinutesRemaining={purchaseCreditsLowCreditMinutesRemaining}
        onClose={onClosePurchaseCredits}
      />
      {destUserInfo ? (
        <TipCreditModal
          isOpen={showTipModal}
          onClose={onCloseTipModal}
          creatorInfo={destUserInfo}
          creatorId={resolvedUserId}
          callMediaType={callMediaType}
          openTipModalRef={openTipModalRefForCall}
          onTipSuccess={handleTipSuccessInCall}
          onOpenCredits={handleOpenCredits}
        />
      ) : null}
    </>
  );
};

export default CallingScreenSubscriberModals;
